export const structure = {
  city: null,
  fields: {},
  mainModalVisibility: false
}
